import { recordApi } from '../../redux/services/record';
import type { ExportRecordsBackgroundJobApiProps } from '../../redux/slices/background-job-slice';
import { appDispatch } from '../../redux/store-accessors';
import { dateFormatBasedOnFilter } from '../../utils/data-transformation-utils';
import { processFieldFilters } from '../../utils/filter-url-builder-utils';
import { ExportBackgroundJobHandler } from './export-background-job.handler';

export class ExportRecordsBackgroundJobHandler extends ExportBackgroundJobHandler<ExportRecordsBackgroundJobApiProps> {
  constructor(apiProps: ExportRecordsBackgroundJobApiProps, details?: Record<string, unknown>) {
    super(apiProps, { ...details });
  }

  protected dispatchCreateJob() {
    const { allForms, moduleId, formId, format, columns, gridOptions, sortDirective, globalHierarchyFilters } =
      this.apiProps;

    const createJobRequest =
      allForms && moduleId
        ? appDispatch(
            recordApi.endpoints.createAllFormsExportJob.initiate({
              moduleId,
              format,
              columns,
              filters: processFieldFilters(gridOptions?.fieldFilters, dateFormatBasedOnFilter),
              sortDirective,
              globalHierarchyFilters,
              captionValuesBase64encoded: true,
            })
          )
        : appDispatch(
            recordApi.endpoints.createExportJob.initiate({
              formId: formId ?? '0',
              format,
              columns,
              filters: processFieldFilters(gridOptions?.fieldFilters, dateFormatBasedOnFilter),
              sortDirective,
              globalHierarchyFilters,
            })
          );

    return createJobRequest.unwrap();
  }
}
